module.exports = __webpack_public_path__ + "static/birdsong-9707e933a0410cfc5bf4ba0748e69a68.png";